var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "distance-bar-container" }, [
    _c(
      "div",
      {
        staticClass: "progress progress-tooltip",
        staticStyle: { height: "20px" }
      },
      [
        _c(
          "div",
          {
            staticClass: "progress-bar progress-bar-tooltip",
            class: _vm.textClass,
            style: { width: _vm.percentage + "%" },
            attrs: {
              role: "progressbar",
              "aria-valuenow": _vm.distance,
              "aria-valuemin": "0",
              "aria-valuemax": _vm.maxDistance
            }
          },
          [
            _vm._v(
              "\n              \n                  " +
                _vm._s(_vm.label) +
                "\n      \n          "
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "progress", staticStyle: { height: "5px" } }, [
      _c("div", {
        staticClass: "progress-bar",
        class: _vm.barClass,
        style: { width: _vm.percentage + "%" },
        attrs: {
          role: "progressbar",
          "aria-valuenow": _vm.distance,
          "aria-valuemin": "0",
          "aria-valuemax": _vm.maxDistance
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }